import Avatar1 from 'images/avatars/avatar1.svg';
import Avatar2 from 'images/avatars/avatar2.svg';
import Avatar3 from 'images/avatars/avatar3.svg';
import Avatar4 from 'images/avatars/avatar4.svg';
import Avatar5 from 'images/avatars/avatar5.svg';
import store from 'state/store/configureStore';
import _ from 'lodash';

const avatars = [Avatar1, Avatar2, Avatar3, Avatar4, Avatar5];

const getRandomAvatar = id => avatars[id % 5];

export const getContributorAvatarUrl = ({
  id: contributorId,
  extended_data
} = {}) => {
  let currentContributor = { extended_data };
  if (!extended_data) {
    const { contributors } = store.getState();
    currentContributor = contributors.find(({ id }) => id === contributorId);
  }
  return (
    _.get(currentContributor, 'extended_data.avatar_url', null) ||
    getRandomAvatar(contributorId)
  );
};

export const getContributorAvatar = ({
  id: contributorId,
  selectedContributorIds = []
} = {}) => {
  const { contributors } = store.getState();
  const currentContributor = contributors.find(
    ({ id }) => id === contributorId
  );
  return {
    id: contributorId,
    isGrayedOut:
      selectedContributorIds.length > 0 &&
      !selectedContributorIds.includes(contributorId),
    name: _.get(currentContributor, 'name', ''),
    url: getContributorAvatarUrl({
      id: contributorId,
      extended_data: _.get(currentContributor, 'extended_data', {})
    })
  };
};

export const getAccountAvatarUrl = (
  { id: accountId, avatar_url },
  accounts = []
) => {
  if (avatar_url) return avatar_url;
  const currentAccount = accounts.find(({ id }) => id === accountId);
  return (
    _.get(currentAccount, 'avatar_url', null) || getRandomAvatar(accountId)
  );
};
